import { useMemo } from "react";
import useUsers from "@/hooks/useUsers";
import { buildFavoriteSourceIndex } from "../lib/favoriteSourceRows";

/**
 * External ids of the sources the current user has favorited. Shares the
 * favorites query with the favorite-documents widget, so a star toggled in one
 * widget shows up in the other without a refetch of its own.
 */
export const useFavoriteSourceIds = (): Set<string> => {
  const { useQueryUsersFavoriteDocuments } = useUsers();
  const { data } = useQueryUsersFavoriteDocuments();

  return useMemo(
    () => buildFavoriteSourceIndex(data?.favoriteLegislations),
    [data?.favoriteLegislations]
  );
};

export default useFavoriteSourceIds;
